import { render, staticRenderFns } from "./UsedItemView.vue?vue&type=template&id=b9c42c38&scoped=true"
import script from "./UsedItemView.vue?vue&type=script&lang=js"
export * from "./UsedItemView.vue?vue&type=script&lang=js"
import style0 from "./UsedItemView.vue?vue&type=style&index=0&id=b9c42c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c42c38",
  null
  
)

export default component.exports